<form [formGroup]="profileForm">
  <div class="profile-container flex-row-container">
    @if (roles) {
    <div class="roles flex-column-container">
      <label for="rolePicker" class="text-uppercase m-b-20">{{ 'role' | translate }}</label>
      <mat-radio-group id="rolePicker" class="flex-column-container" formControlName="selectedRole">
        @for (role of roles; track role) {
        <mat-radio-button data-testid="radio-user-profile-role" [value]="role.id" class="m-b-20">
          {{ role.name }}
        </mat-radio-button>
        }
      </mat-radio-group>
    </div>
    }
    <div class="profile-access-details flex-column-container">
      <label class="text-uppercase m-b-20">{{ 'scope' | translate }}</label>
      <div>
        <mat-checkbox data-testid="checkbox-user-profile" formControlName="isDomainAccess">
          {{ 'user.domain_access' | translate }}</mat-checkbox
        >
      </div>
      <div class="scopes flex-row-container">
        @if (geoScopes) {
        <div class="geo-scope">
          <label for="geo" class="text-uppercase m-b-20">{{ 'geography' | translate }}</label>
          <stx-scope-tree
            id="geo"
            #geotree
            [treeData]="geoScopes"
            [selectedScope]="checkedGeo"
            [isDomainAccess]="isDomainAccess"
            [disabled]="isGeoScopeDisabled"
          ></stx-scope-tree>
        </div>
        } @if (orgTreeScopes) {
        <div class="org-scope">
          <label for="org" class="text-uppercase m-b-20">{{ 'orgtree' | translate }}</label>
          <stx-scope-tree
            id="org"
            #orgtree
            [treeData]="orgTreeScopes"
            [selectedScope]="checkedOrg"
            [isDomainAccess]="isDomainAccess"
          ></stx-scope-tree>
        </div>
        }
      </div>
      <div [formGroup]="profileForm">
        <stx-autocomplete-single-select
          data-testid="select-profile-designated-area"
          labelKey="user.profile_designated_area"
          [formControlName]="'designatedArea'"
          [itemList]="instanceAreaList"
        >
        </stx-autocomplete-single-select>
      </div>
      <div class="flex-column-container">
        <label for="profileName" class="m-b-5">{{ 'user.profile_name' | translate }}</label>
        <mat-form-field appearance="outline" class="input-field-auth">
          <input
            data-testid="input-profile-name"
            type="text"
            matInput
            formControlName="profileNameFormControl"
            class="input-field-auth"
            id="profileName"
          />
          @if (isProfileNameLengthNotValid()) {
          <mat-error class="stx-mat-error-align">{{ 'error.profile_name' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
